export default {
  bind(el, binding) {
    console.log("✅ Lazy load initialized for:", binding.value);

    // Set loader initially
    el.src = "/web/loader-unscreen.gif";
    el.style.opacity = "1"; 
    el.style.padding = "11px";
    el.style.backgroundColor = "#00000035";
    el.style.transition = "opacity 0.5s ease-in-out";

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log("⏳ Image in viewport, loading immediately...");

          el.src = binding.value; // Load real image

          el.onload = () => {
            console.log("✅ Image loaded:", binding.value);
            el.style.opacity = "1"; // Keep visible
            el.style.padding = "0";
            el.style.backgroundColor = "transparent";
          };

          observer.unobserve(el); // Stop observing once loaded
        }
      });
    });

    observer.observe(el);
  }
};
